import React from 'react'
import PropTypes from 'prop-types'

import './slide-styles.scss'
import { EXPORT_CLASS } from '../../ExportDialogContent'

const WIDTH = 1920
const HEIGHT = 1080

const Slide = ({ children }) => {
  return (
    <svg
      width={WIDTH}
      height={HEIGHT}
      viewBox={`0 0 ${WIDTH} ${HEIGHT}`}
      className={`${EXPORT_CLASS} ai-slide`}
    >
      <rect className="ai-slide-background" width={WIDTH} height={HEIGHT} fill="#ffffff" />
      {children}
    </svg>
  )
}

Slide.defaultProps = {}

Slide.propTypes = {
  children: PropTypes.node,
}

export default Slide
